// Styles
import { mergeStyleSets } from "@fluentui/react";
import { flexParent } from "../../../utilities/Mixin.styles";
/**
 * Get the styles for `AIDisclaimerAndFeedback`
 * @param customStyles Optional custom styles to override default styles
 */ export const getStyles = (customStyles)=>{
    const defaultStyles = {
        root: [
            flexParent(),
            {
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px"
            }
        ]
    };
    return mergeStyleSets(defaultStyles, customStyles);
};
